import {Action} from "redux";
import {ICustomerTutorialActionCreator} from "../action/customer_tutorial_action";

interface ICustomerTutorialDispatcher {
    getAllByRecommendProjectList(): void;
}

class Dispatcher implements ICustomerTutorialDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerTutorialActionCreator) {

    }

    public getAllByRecommendProjectList = (): void => {
        this.dispatch(this.actionCreator.requestGetAllByRecommendProjectListAction());
    }

}

const createCustomerTutorialDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerTutorialActionCreator): ICustomerTutorialDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerTutorialDispatcher, createCustomerTutorialDispatcher};


// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_tutorial_dispatcher.ts